import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "../components/Login.css";
import loginimg from "../assets/images/login.avif"
const LoginPage = ({ setAuthenticated }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  // Check if the user is already authenticated on component mount
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setAuthenticated(true);
      navigate("/managecategory"); // Redirect to admin page if already authenticated
    }
  }, [setAuthenticated, navigate]);

  // Generate a simple token (a random string)
  const generateToken = () => {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simulate authentication process (replace with actual logic if needed)
    if (username === "admin" && password === "@Snapper1423") {
      const token = generateToken(); // Generate a simple token
      localStorage.setItem("authToken", token); // Store token in local storage
      setAuthenticated(true);
      navigate("/managecategory");
    } else {
      setError("Invalid credentials");
    }
  };

  return (
<div>
  <h1 style={{ textAlign: "center", color: "#333" }}>
    Snapper Admin Panel
    <hr />
  </h1>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "70vh",
      backgroundColor: "white",
      padding: "20px",
      flexWrap: "wrap", // Enables wrapping on small screens
    }}
  >
    {/* Image Section */}
    <div
      style={{
        flex: 1,
        textAlign: "center",
        maxWidth: "50%", }}
    >
      <img
        src={loginimg}
        alt="Login"
        style={{
          maxWidth: "100%",
          height: "auto",
          borderRadius: "10px",
        }}
      />
    </div>

    {/* Login Form Section */}
    <div
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "400px", // Prevents it from stretching too wide
        width: "100%",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          textAlign: "center",
          width: "100%",
        }}
      >
        <h2 style={{ marginBottom: "20px", color: "#333" }}>Login</h2>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{
              padding: "10px",
              marginBottom: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              fontSize: "16px",
            }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              padding: "10px",
              marginBottom: "20px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              fontSize: "16px",
            }}
          />
          <button
            type="submit"
            style={{
              backgroundColor: "#007bff",
              color: "#fff",
              padding: "10px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Login
          </button>
        </form>
        {error && (
          <div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>{error}</div>
        )}
      </div>
    </div>
  </div>

  {/* Mobile-Responsive Styles */}
  <style>
    {`
      @media (max-width: 768px) {
        div[style*="display: flex"] {
          flex-direction: column;
          height: auto;
        }
        div[style*="max-width: 50%"] {
          max-width: 100%;
        }
        div[style*="max-width: 400px"] {
          max-width: 100%;
          padding: 20px;
        }
      }
    `}
  </style>
</div>

  );
};

export default LoginPage;
